import React, { useContext, useState, useEffect, useRef } from 'react'
import cn from 'classnames'
import { useHistory } from 'react-router-dom'
import { AudioContext } from 'rewact'
import Image from 'react-graceful-image'
import Player from '@vimeo/player'

import { useDelayedState, useTimeout } from '../../hooks'
import * as Icon from '../Icons'
import TrackContext from '../../context/TrackContext'
import SYNC_SELECTION from '../filters/syncSelection'

import styles from './home.module.css'

export default function SyncedItems({ syncTab, openModal }) {
  let history = useHistory()
  const { isPaused, pause, play } = useContext(AudioContext)
  const { setPlayerTrack, playerTrack } = useContext(TrackContext)
  const [preview, setPreview] = useState(null)
  const [isReallyPaused] = useDelayedState(
    isPaused,
    process.env.NODE_ENV === 'production' ? 300 : 100
  )
  return (
    <ul className={styles.covers}>
      {SYNC_SELECTION[syncTab].map(({ name, image, videoId, ...info }) => {
        const isStatic = syncTab === 'Cinema' || syncTab === 'Series'
        const isPlayingPreview = videoId && videoId === preview
        const isActive = playerTrack.slug === info.slug
        function playTrack() {
          const { artist, track, slug } = info
          setPlayerTrack({
            id: `__modal${artist}${name}`,
            artist,
            name: track,
            slug,
            image: `${slug}.jpg`,
          })
          setTimeout(play, 1000)
        }
        return (
          <li
            key={name}
            className={cn(styles.cover, {
              // [styles.static]: isStatic,
            })}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              if (isStatic) {
                if (isActive) {
                  if (isPaused) {
                    play()
                  } else {
                    pause()
                  }
                } else {
                  playTrack()
                }
              } else {
                if (!isPaused) {
                  pause()
                }
                openModal({
                  type: 'video',
                  videoId,
                  hasTrack: info.slug,
                  onClickTrack: () => {
                    history.push('/app')
                    playTrack()
                  },
                  onClickArtist: () => {
                    history.push('/app', { artist: [info.artist] })
                    playTrack()
                  },
                  ...info,
                })
              }
            }}
          >
            <div className={styles.coverBlurWrapper}>
              <div
                style={{ width: '100%', paddingBottom: '100%' }}
                aria-hidden
              />

              <div className={cn(styles.coverImgImg, styles.coverImgImgBlur)}>
                <Image
                  src={require(`../../images/${image}`)}
                  width={150}
                  height={150}
                  alt={`${name} Poster`}
                  className={cn(styles.coverImgImg, styles.coverImgImgBlur)}
                />
              </div>
            </div>
            <div
              className={styles.coverImgContainer}
              onMouseEnter={() => setPreview(videoId)}
              onMouseLeave={() => setPreview(null)}
            >
              <div className={styles.coverImg}>
                <div
                  style={{
                    width: '100%',
                    paddingBottom: isStatic ? '136.223%' : '100%',
                  }}
                  aria-hidden
                />
                <div className={styles.coverImgImg}>
                  <Image
                    src={require(`../../images/${image}`)}
                    width={150}
                    height={150}
                    alt={`${name} Poster`}
                    className={styles.coverImgImg}
                  />
                </div>
              </div>
              {isPlayingPreview ? <VideoPreview videoId={videoId} /> : null}
              <span
                className={cn(styles.coverPlayButton, {
                  [styles.transparent]: isPlayingPreview,
                  [styles.isPlay]: !isActive || isReallyPaused,
                })}
              >
                {isActive && !isReallyPaused ? <Icon.Pause /> : <Icon.Play />}
              </span>
            </div>

            {!isStatic && <h5 className={styles.coverTitle}>{name}</h5>}
          </li>
        )
      })}
    </ul>
  )
}

function VideoPreview({ videoId }) {
  const playerRef = useRef(null)
  const [show, setShow] = useState(false)
  useTimeout(() => setShow(true), 700)
  useEffect(() => {
    let player = new Player(playerRef.current, {
      id: videoId,
      background: true,
      quality: '240p',
    })
    player.play()
    return () => {
      player.destroy()
    }
  }, [videoId])
  return (
    <div
      ref={playerRef}
      className={cn(styles.videoPreview, {
        [styles.show]: show,
      })}
    />
  )
}
